export default __webpack_public_path__ + "static/media/a037-student-1-sc.62b5ff66.png";